"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

/**
 * Astérisque cliquable qui pointe vers la page des conditions de
 * faisabilité. Sert à protéger juridiquement les engagements de délai
 * (7-14 jours, etc.) sans alourdir le contenu.
 */
export function DelayAsterisk({ className = "" }: { className?: string }) {
  const t = useTranslations("conditions");
  return (
    <Link
      href="/conditions-delais"
      aria-label={t("linkLabel")}
      title={t("asterisk")}
      className={`inline-block align-super text-[0.7em] font-medium text-muted-foreground underline-offset-[3px] transition-colors hover:text-aurora-cyan hover:underline ${className}`}
    >
      *
    </Link>
  );
}
